import UserRoles from '@/store/core/user/user-roles'

export default [
  {
    path: '/settings/logs/operation',
    name: 'OperationLogs',
    component: () => import('@/views/operation/logs/OperationLogs.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/automation',
    name: 'Automation',
    component: () => import('../views/operation/automation/Automation.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/action',
    name: 'Actions',
    component: () => import('../views/operation/actions/Actions.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/defaulticon',
    name: 'DefaultIcon',
    component: () => import('../views/operation/defaulticon/DefaultIcon.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER
      ]
    }
  },
  {
    path: '/settings/operation/actionset',
    name: 'Action',
    component: () => import('../views/operation/actionset/Actionset.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/enabler',
    name: 'Enabler',
    component: () => import('../views/operation/enabler/Enabler.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/security',
    name: 'SecurityTabs',
    component: () => import('../views/operation/security/SecurityTabs.vue'),
    children: [
      {
        path: 'category',
        name: 'SecurityCategory',
        component: () => import('../views/operation/security_category/SecurityCategory.vue'),
      },
      {
        path: 'group',
        name: 'SecurityGroup',
        component: () => import('../views/operation/security_group/SecurityGroup.vue'),
      },
      {
        path: 'group/:securityGroupId/security_mark',
        name: 'SecurityMark',
        component: () => import('../views/operation/security_mark/SecurityMark.vue'),
      },
    ],
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/filter',
    name: 'FilterSettings',
    component: () => import('../views/operation/filter/FilterSettings.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/filter/edit/:filterId',
    name: 'FilterEdit',
    component: () => import('../views/operation/filter/FilterEdit.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/pipeline',
    name: 'Pipeline',
    component: () => import('../views/operation/pipeline/Pipeline.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/routine',
    name: 'Routine',
    component: () => import('../views/operation/routine/Routine.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/server',
    name: 'Server',
    component: () => import('../views/operation/server/Server.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  },
  {
    path: '/settings/operation/pipestep',
    name: 'PipeStep',
    component: () => import('../views/operation/pipestep/PipeStep.vue'),
    meta: {
      public: false,
      onlyLoggedOut: false,
      accessRoles: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    }
  }
]
